import React from 'react';

import { Route, Switch } from 'react-router-dom'

import Home from '../views/Home'
import Search from '../views/Search'
import SearchRepositories from '../views/SearchRepositories'
import SearchResult from '../views/SearchResult'
import Item from '../views/Item'
import Issue from '../views/Issue'
import ItemRepository from '../views/ItemRepository'
import ItemDetails from '../views/ItemDetails'
import Copies from '../views/Copies'
import Issues from '../views/Issues'
import Locate from '../views/Locate'
import Libraries from '../views/Libraries'
import LibraryDetails from '../views/LibraryDetails'
import RecentSearches from '../views/RecentSearches'
import Bookmarks from '../views/Bookmarks'
import About from '../views/About'

export default function Container({ location }) {
  return (
    <Switch location={location}>
      <Route path='/home' exact component={Home} />
      <Route path='/search' exact component={Search} />
      <Route path='/search-repositories' exact component={SearchRepositories} />
      <Route path='/search-result' exact component={SearchResult} />
      <Route path='/item/:id?' exact component={Item} />
      <Route path='/issue/:id?' exact component={Issue} />
      <Route path='/item-repository/:id?' exact component={ItemRepository} />
      <Route path='/item-details' exact component={ItemDetails} />
      <Route path='/location' exact component={Locate} />
      <Route path='/copies' exact component={Copies} />
      <Route path='/issues' exact component={Issues} />
      <Route path='/libraries' exact component={Libraries} />
      <Route path='/library-detail' exact component={LibraryDetails} />
      <Route path='/recent-searches' exact component={RecentSearches} />
      <Route path='/bookmarks' exact component={Bookmarks} />
      <Route path='/about' exact component={About} />
      <Route component={Home} />
    </Switch>
  )
}